import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        code: Yup.string().required('Code is required'),
        short_name: Yup.string().required('Short Name is required'),
        applicabl_for: Yup.string().required('Applicable for is required'),
        charge_category: Yup.string().required('Charge Category is required'),
        IATA_code: Yup.string().required('IATA Code is required'),
        // name: Yup.string().required('Code is required'),
    });
// 
    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            code: '',
            short_name: '',
            applicabl_for: '',
            charge_category: '',
            IATA_code: '',
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const ApplicableOption = []
    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Charge Head</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
            <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-6">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="code"
                                    name="code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.code}
                                />
                                {formik.touched.code && formik.errors.code ? (
                                    <div className="error">{formik.errors.code}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Short Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="short_name"
                                    name="short_name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.short_name}
                                />
                                {formik.touched.short_name && formik.errors.short_name ? (
                                    <div className="error">{formik.errors.short_name}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Applicable For <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {formik.touched.applicabl_for && formik.errors.applicabl_for ? (
                                    <div className="error">{formik.errors.applicabl_for}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Charge Catgory <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {formik.touched.charge_category && formik.errors.charge_category ? (
                                    <div className="error">{formik.errors.charge_category}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    IATA Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {formik.touched.IATA_code && formik.errors.IATA_code ? (
                                    <div className="error">{formik.errors.IATA_code}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <div className="card">
                                    <div className="card-header">
                                        Applicable Tax
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3 pb-2 border-bottom">
                                            <div className='col-12'>
                                                <div className="mb-1 form-check">
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" checked={isChecked}
                                                        onChange={(e) => setIsChecked(e.target.checked)} />
                                                    <label className="form-check-label" htmlFor="exampleCheck1">
                                                        Service Tax
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Applicable For <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <Select
                                                    isDisabled={!isChecked}
                                                    className='custom-selector'
                                                    options={ApplicableOption}
                                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                                // onBlur={formik.handleBlur}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Taxable <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    disabled={!isChecked}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="name"
                                                    name="name"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                        </div>

                                        <div className="row mb-3 pb-2 border-bottom">
                                            <div className='col-12'>
                                                <div className="mb-1 form-check">
                                                    <input checked={isChecked1}
                                                        onChange={(e) => setIsChecked1(e.target.checked)} type="checkbox" className="form-check-input" id="exampleCheck3" />
                                                    <label className="form-check-label" htmlFor="exampleCheck3">
                                                    Value Added Tax
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Applicable For <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <Select
                                                    isDisabled={!isChecked1}
                                                    className='custom-selector'
                                                    options={ApplicableOption}
                                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                                // onBlur={formik.handleBlur}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Taxable <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    disabled={!isChecked1}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="name"
                                                    name="name"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                        </div>
                                        <div className="row mb-3 ">
                                            <div className='col-12'>
                                                <div className="mb-1 form-check">
                                                    <input checked={isChecked2}
                                                        onChange={(e) => setIsChecked2(e.target.checked)} type="checkbox" className="form-check-input" id="exampleCheck3" />
                                                    <label className="form-check-label" htmlFor="exampleCheck3">
                                                        Gst
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Applicable For <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <Select
                                                    isDisabled={!isChecked2}
                                                    className='custom-selector'
                                                    options={ApplicableOption}
                                                // value={options.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                                // onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                                // onBlur={formik.handleBlur}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="name" className="form-label">
                                                    Taxable <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    disabled={!isChecked2}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="name"
                                                    name="name"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name}
                                                />
                                                {/* {formik.touched.name && formik.errors.name ? (
                                                    <div className="error">{formik.errors.name}</div>
                                                ) : null} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Submit
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster